import store from "../redux/store";
import CartOperationManager from "./CartOperationManager";
import {
  setCart,
  completeLocationUpdate,
  completeFeeCalculation,
  completeDateUpdate,
  completeItemUpdate,
} from "../redux/cartReducer";
import { processCartResponse } from "../utils/cartResponseUtils";

/**
 * Sets up event listeners for the CartOperationManager
 * This allows automatic state updates when operations complete
 */
class CartOperationEventHandler {
  static initialize() {
    // Listen for operation completions
    CartOperationManager.on("operation:completed", ({ operation, result }) => {
      console.log(
        `[OperationEvent] Operation completed: ${operation.type} (${operation.id})`
      );

      const { dispatch } = store;

      // Update state based on operation type
      switch (operation.type) {
        case "LOCATION_UPDATE":
          dispatch(completeLocationUpdate());

          // Handle clean structure response from backend (Phase 3.1+)
          if (result?.success && result?.cartId) {
            console.log(
              "[DEBUG] LOCATION_UPDATE: Processing clean structure response"
            );
            dispatch(setCart(processCartResponse(result)));
          }
          break;

        case "QUANTITY_UPDATE":
          console.log(
            "[DEBUG] QUANTITY_UPDATE operation completed with result:",
            result
          );
          console.log("[DEBUG] Operation details:", operation);

          if (operation.groupIds?.length) {
            dispatch(
              completeItemUpdate({
                itemId: operation.params.cartCustomId,
                groupId: operation.groupIds[0],
              })
            );

            // Also complete fee calculation
            dispatch(completeFeeCalculation(operation.groupIds[0]));
          }

          // CRITICAL FIX: Handle clean structure response from backend (Phase 3.1+)
          if (result?.success && result?.cartId) {
            console.log(
              "[DEBUG] QUANTITY_UPDATE: Processing clean structure response"
            );
            console.log("[DEBUG] Cart data being processed:", {
              cartId: result.cartId,
              cartVersion: result.cartVersion,
              groupsCount: result.groups?.length,
              totalsGrandTotal: result.totals?.grandTotal,
            });
            dispatch(setCart(processCartResponse(result)));
          } else {
            console.warn(
              "[DEBUG] QUANTITY_UPDATE: No valid cart data in result - cart state not updated!"
            );
            console.log(
              "[DEBUG] Full result object:",
              JSON.stringify(result, null, 2)
            );
          }
          break;

        case "DATE_UPDATE":
          if (operation.groupIds?.length) {
            dispatch(completeDateUpdate(operation.groupIds[0]));
          }
          break;

        case "ITEM_REMOVAL":
          if (operation.groupIds?.length) {
            dispatch(
              completeItemUpdate({
                itemId: operation.params.cartCustomId,
                groupId: operation.groupIds[0],
              })
            );

            // Also complete fee calculation
            dispatch(completeFeeCalculation(operation.groupIds[0]));
          }

          // Handle clean structure response from backend (Phase 3.1+)
          if (result?.success && result?.cartId) {
            console.log(
              "[DEBUG] ITEM_REMOVAL: Processing clean structure response"
            );
            dispatch(setCart(processCartResponse(result)));
          } else {
            console.warn(
              "[DEBUG] ITEM_REMOVAL: No valid cart data in result - cart state not updated!"
            );
            console.log(
              "[DEBUG] Full result object:",
              JSON.stringify(result, null, 2)
            );
          }
          break;
      }
    });

    // Listen for operation failures
    CartOperationManager.on("operation:failed", ({ operation, error }) => {
      console.error(
        `[OperationEvent] Operation failed: ${operation.type} (${operation.id})`,
        error
      );

      const { dispatch } = store;

      // Handle failure based on operation type
      switch (operation.type) {
        case "LOCATION_UPDATE":
          dispatch(completeLocationUpdate());
          break;

        case "QUANTITY_UPDATE":
        case "ITEM_REMOVAL":
          console.error(
            "[DEBUG] QUANTITY_UPDATE/ITEM_REMOVAL operation failed:",
            error
          );
          console.log("[DEBUG] Failed operation details:", operation);

          if (operation.groupIds?.length) {
            dispatch(
              completeItemUpdate({
                itemId: operation.params.cartCustomId,
                groupId: operation.groupIds[0],
              })
            );
            dispatch(completeFeeCalculation(operation.groupIds[0]));
          }

          console.warn(
            "[DEBUG] Cart state NOT updated due to operation failure"
          );
          break;

        case "DATE_UPDATE":
          if (operation.groupIds?.length) {
            dispatch(completeDateUpdate(operation.groupIds[0]));
          }
          break;
      }
    });
  }
}

export default CartOperationEventHandler;
